import { IToastNotification } from 'interface/toastNotification';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ComponentItem from './ComponentItem';

const ToastNotification = ({ messages }: IToastNotification) => {

  if (!messages || messages.length < 1) return null;

  return (
    <Fragment>
      {messages.map((m, index) => {
        return (
          <ComponentItem key={m.id} message={m} index={index} />
        );
      })}
    </Fragment>
  );
}

const mapStateToProps = (state: any) => {
  return {
    messages: state.toastNotification?.messages
  }
}

export default connect(mapStateToProps)(ToastNotification);